<section class="companies-page">
  <header class="page-header">
    <div>
      <h1>{{ translationService.getCompaniesText() }}</h1>
      <p>{{ translationService.getCompanyCountText(totalRecords) }}</p>
    </div>
    <a
      mat-raised-button
      color="accent"
      class="create-button"
      [routerLink]="['/admin/companies/create']"
    >
      <mat-icon>add</mat-icon>{{ translationService.getCreateCompanyText() }}
    </a>
  </header>

  <div class="privacy-notice">
    <mat-icon>lock_outline</mat-icon>
    <div>
      <strong>{{
        translationService.getCompaniesPrivateByDefaultText()
      }}</strong>
      <p>{{ translationService.getCompaniesPublicationNoticeText() }}</p>
    </div>
  </div>

  <form class="filters" (ngSubmit)="filterChange()">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>{{
        translationService.getSearchCompaniesByNameText()
      }}</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        [(ngModel)]="filterValues.name"
        (ngModelChange)="queueNameFilter()"
        name="name"
        type="search"
      />
    </mat-form-field>
    <mat-form-field appearance="outline" class="visibility-field">
      <mat-label>{{ translationService.getVisibilityText() }}</mat-label>
      <mat-select
        [(ngModel)]="filterValues.visibility"
        name="visibility"
        (selectionChange)="filterChange()"
      >
        <mat-option value="all">{{
          translationService.getAllText()
        }}</mat-option>
        <mat-option value="public">{{
          translationService.getPublicText()
        }}</mat-option>
        <mat-option value="private">{{
          translationService.getPrivateText()
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <button
      mat-button
      type="button"
      class="reset-button"
      (click)="resetFilter()"
    >
      {{ translationService.getResetText() }}
    </button>
  </form>

  <div class="companies-table">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getCompanyText() }}
        </th>
        <td mat-cell *matCellDef="let company" class="company-name-cell">
          <mat-icon>apartment</mat-icon><strong>{{ company.name }}</strong>
        </td>
      </ng-container>
      <ng-container matColumnDef="visibility">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getProductVisibilityText() }}
        </th>
        <td mat-cell *matCellDef="let company" class="visibility-cell">
          <div class="visibility-control">
            <mat-slide-toggle
              [checked]="company.isMarketplacePublic"
              [disabled]="savingCompanyId === company.id"
              (change)="setMarketplacePublication(company, $event)"
              [attr.aria-label]="translationService.getMakeProductsPublicText()"
            ></mat-slide-toggle>
            <span>{{ translationService.getMakeProductsPublicText() }}</span>
            <span class="state">{{
              company.isMarketplacePublic
                ? translationService.getOnText()
                : translationService.getOffText()
            }}</span>
          </div>
          <p class="visibility-status">
            <mat-icon>{{
              company.isMarketplacePublic ? 'public' : 'lock_outline'
            }}</mat-icon>
            {{
              company.isMarketplacePublic
                ? translationService.getMarketplacePublishedText()
                : translationService.getMarketplacePrivateText()
            }}
          </p>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          {{ translationService.getActionsText() }}
        </th>
        <td mat-cell *matCellDef="let company" class="actions-cell">
          <a
            mat-stroked-button
            class="view-button"
            [routerLink]="['/admin/companies/products']"
            [queryParams]="{ companyId: company.id }"
          >
            {{ translationService.getViewText() }}
          </a>
          <button
            class="action-link"
            type="button"
            (click)="manageConnections(company)"
          >
            {{ translationService.getManageConnectionsText() }}
          </button>
          <button
            class="action-link"
            type="button"
            (click)="toggleCompanyActive(company.id)"
          >
            {{
              company.is_active
                ? translationService.getDeactivateCompanyText()
                : translationService.getActivateText()
            }}
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      [length]="totalRecords"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 50]"
      [pageIndex]="pageIndex"
      (page)="onPageChange($event)"
    ></mat-paginator>
  </div>
</section>
